import React from "react";
import { Table } from "react-bootstrap";
import "../../../assets/styles/scheduledChanges.scss";

const ScheduledChangeDetailFilters = ({ changeDetailsJson }) => {
  const parsedChangeDetails = React.useMemo(() => {
    if (!changeDetailsJson) return null;

    if (typeof changeDetailsJson === "object") {
      return changeDetailsJson;
    }

    try {
      return JSON.parse(String(changeDetailsJson));
    } catch {
      return null;
    }
  }, [changeDetailsJson]);

  const filtersRows = React.useMemo(() => {
    const filters = parsedChangeDetails?.Filters ?? parsedChangeDetails?.filters;

    if (Array.isArray(filters)) {
      return filters.filter((item) => item && typeof item === "object");
    }

    if (filters && typeof filters === "object") {
      return [filters];
    }

    return [];
  }, [parsedChangeDetails]);

  const normalizedFilters = React.useMemo(() => {
    return filtersRows.map((row, index) => {
      const key =
        row?.Column ??
        row?.column ??
        row?.Colunm ??
        row?.colunm ??
        `Filtr ${index + 1}`;

      const value = row?.Value ?? row?.value ?? "-";

      return {
        key: String(key),
        value,
      };
    });
  }, [filtersRows]);

  const renderPrimitive = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
  };

  return (
    <div className="sc-detail-table-shell sc-detail-table-shell--filters">
      <h5 className="sc-detail-table__section-title sc-detail-table__section-title--filters">
        Filtry
      </h5>

      <Table size="sm" className="sc-detail-table mb-0" responsive>
        <tbody>
          {normalizedFilters.length === 0 ? (
            <tr>
              <td className="sc-detail-table__value">Brak danych w Filters.</td>
            </tr>
          ) : (
            <>
              {normalizedFilters.map((filter, index) => (
                <React.Fragment key={`filter-${index}-${filter.key}`}>
                  <tr>
                    <td className="sc-detail-table__label">{filter.key}</td>
                    <td className="sc-detail-table__value">
                      <span className="sc-detail-table__text">{renderPrimitive(filter.value)}</span>
                    </td>
                  </tr>
                  {index < normalizedFilters.length - 1 && (
                    <tr className="sc-detail-table__record-spacer" aria-hidden="true">
                      <td colSpan={2}></td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ScheduledChangeDetailFilters;
